[
  {
    "code": "PG-CPM",
    "name": "Central"
  },
  {
    "code": "PG-CPK",
    "name": "Chimbu"
  },
  {
    "code": "PG-EBR",
    "name": "East New Britain"
  },
  {
    "code": "PG-ESW",
    "name": "East Sepik"
  },
  {
    "code": "PG-EHG",
    "name": "Eastern Highlands"
  },
  {
    "code": "PG-EPW",
    "name": "Enga"
  },
  {
    "code": "PG-GPK",
    "name": "Gulf"
  },
  {
    "code": "PG-MPM",
    "name": "Madang"
  },
  {
    "code": "PG-MRL",
    "name": "Manus"
  },
  {
    "code": "PG-MBA",
    "name": "Milne Bay"
  },
  {
    "code": "PG-MPL",
    "name": "Morobe"
  },
  {
    "code": "PG-NCD",
    "name": "National Capital District (Port Moresby)"
  },
  {
    "code": "PG-NIK",
    "name": "New Ireland"
  },
  {
    "code": "PG-NSA",
    "name": "North Solomons (Bougainville)"
  },
  {
    "code": "PG-NPP",
    "name": "Northern"
  },
  {
    "code": "PG-SAN",
    "name": "Sandaun (West Sepik)"
  },
  {
    "code": "PG-SHM",
    "name": "Southern Highlands"
  },
  {
    "code": "PG-WBK",
    "name": "West New Britain"
  },
  {
    "code": "PG-WPD",
    "name": "Western"
  },
  {
    "code": "PG-WHM",
    "name": "Western Highlands"
  }
]